export const CONVERSATION_FETCH_REQUEST =
  "@@conversation/CONVERSATION_FETCH_REQUEST";
export const CONVERSATION_FETCH_FAILURE =
  "@@conversation/CONVERSATION_FETCH_FAILURE";
export const CONVERSATION_FETCH_SUCCESS =
  "@@conversation/CONVERSATION_FETCH_SUCCESS";

export const CONVERSATION_CREATE_MESSAGE_REQUEST =
  "@@conversation/CONVERSATION_CREATE_MESSAGE_REQUEST";
export const CONVERSATION_CREATE_MESSAGE_FAILURE =
  "@@conversation/CONVERSATION_CREATE_MESSAGE_FAILURE";
export const CONVERSATION_CREATE_MESSAGE_SUCCESS =
  "@@conversation/CONVERSATION_CREATE_MESSAGE_SUCCESS";

export const CONVERSATION_MESSAGE_RECIEVED =
  "@@conversation/CONVERSATION_MESSAGE_RECIEVED";
